/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {DashboardWrapper} from './containers/DashboardMain'

export function DashboardPage() {
  useEffect(() => {}, [])

  return (
    <div>
      <Switch>
        <Route path='/dashboard' exact={true} component={DashboardWrapper} />
        <Redirect to='/dashboard' />
      </Switch>
    </div>
  )
}
